import Config from 'utils/packages/configs';
import { v4 as uuidV4 } from 'uuid';
import { getAccessToken } from 'middleware/api';
import { tryAtMost } from '../utils/network';
import * as invest from '../types';
export const createOrder = async (amountOrQuantity, assetId, tradingAccountId, operation, pin, orderType, limitPrice, stopPrice, timeInForce) => {
    const url = `${Config.API_URL}/wealth/trading/orders`;
    const access_token = (await getAccessToken.next({ next: undefined, errorType: 'CREATE_ORDER_FAILURE', pin, scope: 'order:write' })).value;
    if (access_token === null) {
        throw new Error('Refresh token expired');
    }
    const response = await tryAtMost(url, {
        method: 'POST',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            Authorization: `Bearer ${access_token}`,
            'Client-Date': new Date().toString(),
            'X-Request-ID': uuidV4(),
        },
        data: operation === 'buy'
            ? {
                assetId,
                orderType,
                operation,
                limitPrice,
                accountId: tradingAccountId,
                [orderType === invest.OrderType.LIMIT ? 'quantity' : 'amount']: amountOrQuantity,
            }
            : {
                assetId,
                operation,
                stopPrice,
                orderType,
                limitPrice,
                timeInForce,
                quantity: amountOrQuantity,
                accountId: tradingAccountId,
            },
    }, 2, true);
    return response.data;
};
